module.exports = __webpack_public_path__ + "f70ffcbb364035d6d8e7556a471deade.svg";